import * as Yup from 'yup';

// TYPES
import { IRequestTransferenciasMunicipios } from 'store/modules/api/detranCrv/SolicitarDocumentos/emitirTransferenciaMunicipio/types';

// UTILS
import {
	limparMascara,
	unformatDate,
	separarDDD,
} from 'utils/genericFunctions';

import { formatRg } from '../../formFunctions';

export interface IEvento {
	id_atendimento: string;
	id_cidadao: string;
	cpf: string;
	identificacao: string;
	ip: string;
	idAtendimento?: string;
	idCidadao?: string;
	canal?: {
		id: number;
		desc: string;
		localidade: {
			id: number;
			desc: string;
		};
	};
}
export interface IEmiteTransferenciaVeiculo {
	evento: IEvento;
	renavam: string;
	placa: string;
	protocoloRemacarcao: string;
	codigoMunicipio: number | string;
	descricaoMunicipio: string;
	numeroEspelhoAnterior: string;
	chassi: string;
	chassiRemarcado: boolean;
	longIdMarca: number | string;
	descricaoMarca: string;
	anoFabricacao: number | string;
	anoModelo: number | string;
	longIdTipo: number | string;
	descricaoTipo: string;
	longIdCarroceria: number | string;
	descricaoCarroceria: string;
	longIdCor: number | string;
	descricaoCor: string;
	longIdCategoria: number | string;
	descricaoCategoria: string;
	longIdCombustivel: number | string;
	descricaoCombustivel: string;
	longIdEspecie: number | string;
	descricaoEspecie: string;
	capacidadePassageiros: number | string;
	capacidadeCarga: number | string;
	potencia: number | string;
	cilindrada: number | string;
	cmt: number | string;
	pbt: number | string;
	eixos: number | string;
	procedencia: string;
	nomeProprietario: string;
	cepProprietario: string;
	bairroProprietario: string;
	enderecoProprietario: string;
	numeroProprietario: string;
	complementoProprietario: string;
	telefone: string;
	codigoMunicipioProprietario: number | string;
	descricaoMunicipioProprietario: string;
	codigoMunicipioPlacaAnterior: number | string;
	descricaoMunicipioPlacaAnterior: string;
	nomeProprietarioAnterior: string;
	placaAnterior: string;
	ufPlacaAnterior: string;
	identificacao: string;
	rgProprietario: string;
	rgDigito: string;
	orgaoExpeditorProprietario: string;
	ufProprietario: string;
	cpfCnpjProprietario: string;
	ufEspelhoAnterior: string;
	arrendatarioFinanceira: string;
	codigoFinanceira: string | number;
	numeroContrato: string;
	restricao: string;
	dataVigencia: string;
	autenticacaoDigitalDut: string;
	codBanco: string;
	dataContabil: string;
	nsuProdesp: string;
	autenticacaoDigitalEmpl: string;
	taxaAutenticacaoDigital: string;
	documentos: any;
	servicoDigital: boolean;
	emailCidadao: string;
	dddTelefoneCidadao: string;
}

export const initialValues: IEmiteTransferenciaVeiculo = {
	evento: {
		id_atendimento: '',
		id_cidadao: '',
		cpf: '',
		identificacao: '',
		ip: '',
		canal: {
			id: 0,
			desc: '',
			localidade: {
				id: 0,
				desc: '',
			},
		},
	},
	renavam: '',
	protocoloRemacarcao: '',
	placa: '',
	codigoMunicipio: '',
	descricaoMunicipio: '',
	numeroEspelhoAnterior: '',
	chassi: '',
	chassiRemarcado: false,
	longIdMarca: '',
	descricaoMarca: '',
	anoModelo: '',
	longIdTipo: '',
	descricaoTipo: '',
	longIdCarroceria: '',
	descricaoCarroceria: '',
	longIdCor: '',
	descricaoCor: '',
	longIdCategoria: '',
	descricaoCategoria: '',
	longIdCombustivel: '',
	descricaoCombustivel: '',
	longIdEspecie: '',
	descricaoEspecie: '',
	capacidadePassageiros: '',
	capacidadeCarga: '',
	potencia: '',
	cilindrada: '',
	cmt: '',
	pbt: '',
	eixos: '',
	procedencia: '',
	nomeProprietario: '',
	cepProprietario: '',
	bairroProprietario: '',
	enderecoProprietario: '',
	numeroProprietario: '',
	complementoProprietario: '',
	telefone: '',
	codigoMunicipioProprietario: '',
	descricaoMunicipioProprietario: '',
	codigoMunicipioPlacaAnterior: '',
	descricaoMunicipioPlacaAnterior: '',
	rgProprietario: '',
	rgDigito: '',
	orgaoExpeditorProprietario: '',
	ufProprietario: '',
	anoFabricacao: '',
	nomeProprietarioAnterior: '',
	placaAnterior: '',
	ufPlacaAnterior: '',
	identificacao: 'FISICA',
	cpfCnpjProprietario: '',
	ufEspelhoAnterior: '',
	arrendatarioFinanceira: '',
	codigoFinanceira: '',
	numeroContrato: '',
	restricao: '',
	dataVigencia: '',
	autenticacaoDigitalDut: '',
	autenticacaoDigitalEmpl: '',
	taxaAutenticacaoDigital: '',
	codBanco: '',
	dataContabil: '',
	nsuProdesp: '',
	documentos: [],
	servicoDigital: true,
	emailCidadao: '',
	dddTelefoneCidadao: '',
};

export const schema = Yup.object<IEmiteTransferenciaVeiculo>().shape({
	placa: Yup.string().required('Campo Obrigatório: Placa.'),
	municipio: Yup.string().when(['codigoMunicipio', 'descricaoMunicipio'], {
		is: (codigoMunicipio, descricaoMunicipio) =>
			[codigoMunicipio, descricaoMunicipio].includes(''),
		then: Yup.string().required('Campo Obrigatório: Município.'),
	}),

	codigoMunicipioProprietario: Yup.string().required(
		'Campo Obrigatório: Município Proprietário.',
	),
	municipioProprietario: Yup.string().when(
		['codigoMunicipioProprietario', 'descricaoMunicipioProprietario'],
		{
			is: (codigoMunicipioProprietario, descricaoMunicipioProprietario) =>
				[codigoMunicipioProprietario, descricaoMunicipioProprietario].includes(
					'',
				),
			then: Yup.string().required('Campo Obrigatório: Município Proprietário.'),
		},
	),
	numeroEspelhoAnterior: Yup.string().required(
		'Campo Obrigatório: Espelho Anterior.',
	),
	chassi: Yup.string().required('Campo Obrigatório: Chassi.'),
	chassiRemarcado: Yup.string().required(
		'Campo Obrigatório: Chassi Remarcado.',
	),
	marca: Yup.string().when(['descricaoMarca', 'longIdMarca'], {
		is: (descricaoMarca, longIdMarca) =>
			[descricaoMarca, longIdMarca].includes(''),
		then: Yup.string().required('Campo Obrigatório: Marca.'),
	}),
	anoModelo: Yup.string().required('Campo Obrigatório: Ano Modelo.'),
	anoFabricacao: Yup.string().required('Campo Obrigatório: Ano Fabricação.'),
	tipo: Yup.string().when(['descricaoTipo', 'longIdTipo'], {
		is: (descricaoTipo, longIdTipo) => [descricaoTipo, longIdTipo].includes(''),
		then: Yup.string().required('Campo Obrigatório: Tipo.'),
	}),
	carroceria: Yup.string().when(['descricaoCarroceria', 'longIdCarroceria'], {
		is: (descricaoCarroceria, longIdCarroceria) =>
			[descricaoCarroceria, longIdCarroceria].includes(''),
		then: Yup.string().required('Campo Obrigatório: Carroceria.'),
	}),
	cor: Yup.string().when(['descricaoCor', 'longIdCor'], {
		is: (descricaoCor, longIdCor) => [descricaoCor, longIdCor].includes(''),
		then: Yup.string().required('Campo Obrigatório: Cor.'),
	}),
	categoria: Yup.string().when(['descricaoCategoria', 'longIdCategoria'], {
		is: (descricaoCategoria, longIdCategoria) =>
			[descricaoCategoria, longIdCategoria].includes(''),
		then: Yup.string().required('Campo Obrigatório: Categoria.'),
	}),
	combustivel: Yup.string().when(
		['descricaoCombustivel', 'longIdCombustivel'],
		{
			is: (descricaoCombustivel, longIdCombustivel) =>
				[descricaoCombustivel, longIdCombustivel].includes(''),
			then: Yup.string().required('Campo Obrigatório: Combustível.'),
		},
	),
	especie: Yup.string().when(['descricaoEspecie', 'longIdEspecie'], {
		is: (descricaoEspecie, longIdEspecie) =>
			[descricaoEspecie, longIdEspecie].includes(''),
		then: Yup.string().required('Campo Obrigatório: Espécie.'),
	}),
	capacidadePassageiros: Yup.string().required(
		'Campo Obrigatório: Capacidade Passageiros.',
	),
	capacidadeCarga: Yup.string().required(
		'Campo Obrigatório: Capacidade Carga.',
	),
	potencia: Yup.string().required('Campo Obrigatório: Potência.'),
	cilindrada: Yup.string().required('Campo Obrigatório: Cilindrada.'),
	cmt: Yup.string().required('Campo Obrigatório: CMT.'),
	pbt: Yup.string().required('Campo Obrigatório: PBT.'),
	eixos: Yup.string().required('Campo Obrigatório: Eixos.'),
	procedencia: Yup.string().required(
		'Campo Obrigatório: Procedência do veículo.',
	),
	nomeProprietario: Yup.string().required('Campo Obrigatório: Nome.'),
	cepProprietario: Yup.string().required('Campo Obrigatório: CEP do imóvel.'),
	bairroProprietario: Yup.string().required('Campo Obrigatório: Bairro.'),
	enderecoProprietario: Yup.string().required('Campo Obrigatório: Endereço.'),
	numeroProprietario: Yup.string().required('Campo Obrigatório: Número.'),
	cpfCnpjProprietario: Yup.string().required(
		'Campo Obrigatório: CPF/CNPJ Proprietário.',
	),
	nomeProprietarioAnterior: Yup.string().required(
		'Campo Obrigatório: Nome Proprietário Anterior.',
	),
	rgProprietario: Yup.string().when(['identificacao'], {
		is: identificacao => identificacao === 'FISICA',
		then: Yup.string().required(`Campo Obrigatório: RG do Proprietário Atual.`),
	}),
	orgaoExpeditorProprietario: Yup.string().when(['identificacao'], {
		is: identificacao => identificacao === 'FISICA',
		then: Yup.string().required(`Campo Obrigatório: Orgão Expedidor.`),
	}),
	ufProprietario: Yup.string().when(['identificacao'], {
		is: identificacao => identificacao === 'FISICA',
		then: Yup.string().required(`Campo Obrigatório: UF.`),
	}),
	emailCidadao: Yup.string().when('servicoDigital', {
		is: servicoDigital => servicoDigital === true,
		then: Yup.string().required(`Campo Obrigatório: E-mail.`),
	}),
	dddTelefoneCidadao: Yup.string().when('servicoDigital', {
		is: servicoDigital => servicoDigital === true,
		then: Yup.string()
			.test(
				'len',
				'Insira o DDD e o número do telefone.',
				(val: any) => val.replace(/\D/g, '').length === 11,
			)
			.required(`Campo Obrigatório: Telefone de Contato.`),
	}),
	documentos: Yup.string().required(`Campo Obrigatório: Anexo de documento.`),
	// documentos: Yup.string().when('servicoDigital', {
	// 	is: servicoDigital => servicoDigital === true,
	// 	then: Yup.string().required(`Campo Obrigatório: Anexo de documento.`),
	// }),
});

export function treatValues(
	formValues: IEmiteTransferenciaVeiculo,
	evento: IEvento,
): IRequestTransferenciasMunicipios {
	const {
		anoModelo,
		capacidadeCarga,
		capacidadePassageiros,
		chassi,
		chassiRemarcado,
		cilindrada,
		cmt,
		descricaoMunicipio,
		eixos,
		codigoMunicipio,
		numeroEspelhoAnterior,
		pbt,
		placa,
		potencia,
		procedencia,
		longIdCarroceria,
		descricaoCarroceria,
		longIdCategoria,
		descricaoCategoria,
		longIdCombustivel,
		descricaoCombustivel,
		longIdCor,
		descricaoCor,
		longIdEspecie,
		descricaoEspecie,
		longIdMarca,
		descricaoMarca,
		longIdTipo,
		descricaoTipo,
		nomeProprietario,
		cepProprietario,
		enderecoProprietario,
		numeroProprietario,
		complementoProprietario,
		bairroProprietario,
		telefone,
		codigoMunicipioProprietario,
		descricaoMunicipioProprietario,
		codigoMunicipioPlacaAnterior,
		descricaoMunicipioPlacaAnterior,
		nomeProprietarioAnterior,
		placaAnterior,
		ufPlacaAnterior,
		rgProprietario,
		rgDigito,
		orgaoExpeditorProprietario,
		ufProprietario,
		identificacao,
		cpfCnpjProprietario,
		anoFabricacao,
		renavam,
		ufEspelhoAnterior,
		arrendatarioFinanceira,
		dataVigencia,
		codigoFinanceira,
		numeroContrato,
		restricao,
		// autenticacaoDigitalDut,
		// codBanco,
		// dataContabil,
		// nsuProdesp,
		protocoloRemacarcao,
		taxaAutenticacaoDigital,
		documentos,
		emailCidadao,
		servicoDigital,
		dddTelefoneCidadao,
	} = formValues;

	const { ddd, numTelefone } = separarDDD(dddTelefoneCidadao);
	const formatedRg = formatRg(rgProprietario, rgDigito);

	const requestValues: IRequestTransferenciasMunicipios = {
		evento: {
			id_atendimento: evento.id_atendimento,
			id_cidadao: evento.id_cidadao,
			ip: evento.ip,
			identificacao: evento.identificacao,
			cpf: evento.cpf || '',
			canal: {
				id: 1,
				desc: 'Presencial',
				localidade: {
					desc: evento.canal?.localidade.desc || '',
					id: evento.canal?.localidade.id || 0,
				},
			},
		},
		placa,
		chassi,
		ufEspelhoAnterior,
		espelhoAnterior: numeroEspelhoAnterior ? Number(numeroEspelhoAnterior) : 0,
		protocoloRemarcacao: protocoloRemacarcao ? Number(protocoloRemacarcao) : 0,
		renavam: Number(renavam),
		chassiRemarcado,
		anoFabricacao: Number(anoFabricacao),
		anoModelo: Number(anoModelo),
		capacidadePassageiro: Number(capacidadePassageiros),
		capacidadeCarga: capacidadeCarga ? Number(capacidadeCarga) : 0,
		potencia: Number(potencia),
		cilindrada: Number(cilindrada),
		cmt: Number(cmt),
		pbt: Number(pbt),
		eixo: Number(eixos),
		procedencia,
		carroceria: {
			longId: Number(longIdCarroceria),
			descricao: descricaoCarroceria,
		},
		categoria: {
			longId: Number(longIdCategoria),
			descricao: descricaoCategoria,
		},
		combustivel: {
			longId: Number(longIdCombustivel),
			descricao: descricaoCombustivel,
		},
		cor: {
			longId: Number(longIdCor),
			descricao: descricaoCor,
		},
		especie: {
			longId: Number(longIdEspecie),
			descricao: descricaoEspecie,
		},
		marca: {
			longId: Number(longIdMarca),
			descricao: descricaoMarca,
		},
		tipo: {
			longId: Number(longIdTipo),
			descricao: descricaoTipo,
		},
		gravame: {
			arrendatarioFinanceira,
			dataVigencia: unformatDate(dataVigencia),
			financeira: Number(codigoFinanceira),
			numeroContrato,
			restricaoFinanceira: restricao,
		},
		municipio: {
			codigo: Number(codigoMunicipio),
			nome: descricaoMunicipio,
		},
		proprietario: {
			nomeProprietario,
			cepProprietario: Number(limparMascara(cepProprietario)),
			bairro: bairroProprietario,
			enderecoProprietario,
			numero: Number(numeroProprietario),
			complemento: complementoProprietario,
			telefone: telefone ? Number(limparMascara(telefone)) : 0,
			identificacao,
			cpfCnpjProprietario: Number(limparMascara(cpfCnpjProprietario)),
			rgProprietario: Number(formatedRg),
			orgaoExpeditorProprietario,
			ufProprietario,
			nomeProprietarioAnterior,
			municipioProprietario: {
				codigo: Number(codigoMunicipioProprietario),
				nome: descricaoMunicipioProprietario,
			},
		},
		placaAnterior,
		ufPlacaAnterior,
		municipioPlacaAnterior: {
			codigo: Number(codigoMunicipioPlacaAnterior),
			nome: descricaoMunicipioPlacaAnterior,
		},
		taxaAutenticacaoDigital,
		documentos,
		emailCidadao,
		dddTelefoneCidadao: ddd !== '' ? Number(ddd) : 0,
		telefoneCidadao: numTelefone !== '' ? Number(numTelefone) : 0,
		servicoDigital,
		// numeroEspelhoAnterior: numeroEspelhoAnterior
		// 	? Number(numeroEspelhoAnterior)
		// 	: 0,
		// taxa: {
		// 	// autenticacaoDigitalDut,
		// 	codBanco: completaZeroEsquerda(codBanco, 3),
		// 	dataContabil: formatDateISO(dataContabil),
		// 	nsuProdesp: completaZeroEsquerda(nsuProdesp, 9),
		// },
	};

	return requestValues;
}
